import SiteContentEditor from "@/project/jain_elibrary-admin/pages/content/SiteContentEditor";

/** Bottom copyright strip on the public site. Slug: `footer`. */
const FooterContent = () => (
  <SiteContentEditor slug="footer" heading="Footer (copyright strip)" />
);

export default FooterContent;
